//import store from '../store';

export default ({ payload }) => {
  // Do nothing here
}
